<template>
  <div class="accordion-tabs" :class="[cssClasses, typeClass]">
    <nav :class="['tabs__triggers', {'tabs__triggers--is-hidden': hideButtons}]">
      <button
        v-for="tab of tabs"
        :key="tab.name"
        :class="['tabs__trigger', { 'tabs__trigger--is-active': tab.isActive }]"
        @click="changeTab(tab)">
        {{ tab.displayName }}
      </button>
    </nav>
    <div class="tabs__container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    hideButtons: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabs: []
  }),
  computed: {
    typeClass() {
      return `accordion-tabs--${this.type}`
    }
  },
  mounted() {
    this.subscribe(`accordion-change-tab-${this.name}`, (tabName) => {
      var tab = _.find(this.tabs, tab => tab.name === tabName)
      this.changeTab(tab)
    })
  },
  created() {
    this.tabs = this.$children
  },
  methods: {
    changeTab(tab) {
      this.publish(`accordion-tab-changed`, tab.name)
      this.tabs.map(t => {
        t.isActive = t.name === tab.name
      })
    }
  }
}
</script>

<style lang="scss">
.tabs__triggers {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 2px solid color(gray-4);

  @include media(to-medium) {
    flex-direction: column;
  }
}

.tabs__triggers--is-hidden {
  display: none;
  margin-bottom: 0;
}

.tabs__trigger {
  @include reset-button;
  position: relative;
  padding: measure(quarter) measure(half);
  transition: all .2s ease;
}

.tabs__trigger--is-active::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  bottom: -2px;
  border-bottom: 2px solid color(brand-blue-3);
}

.tabs__accordion-content {
  padding-top: measure(full);

  @include media(to-medium) {
    display: none;
  }

  @include media(medium) {
    display: none;
  }
}

.tabs__accordion-content[aria-hidden="false"],
.tabs__accordion-content--is-active {
  @include media(to-medium) {
    display: block;
  }

  @include media(medium) {
    display: block;
  }
}
</style>
